import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { ConfiguratorApi } from '@/utils/ConfiguratorApi';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PlannerEnv } from '@/utils/env';
import { PlannerPageContainer } from './PlannerPageContainer';

export function ViewPlannerPage() {
  // To be used later to pass down the identifier or draft id to the EditContainer
  const { plannerId, env } = useParams();

  const [planner, setPlanner] =
    useState<PlannerConfigEntityWithOptionalFields>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setError('');
    if (env && plannerId) {
      ConfiguratorApi.getInstance()
        .getPublishedPlanner(env as PlannerEnv, plannerId)
        .then((it) => setPlanner(it))
        .catch(() => setError('Planner not found'));
    }
  }, [env, plannerId]);

  if (error) {
    return <div>{error}</div>;
  }

  if (planner) {
    return (
      <PlannerPageContainer
        mode='edit'
        planner={planner}
        title={`View planner ${planner.identifier}`}
        description=''
        onSubmit={() => {}}
        disabledPhraseFields
        disabledFormFields
      />
    );
  }

  return null;
}
